<template>
  <div class="card border-0 bg-white profile-settings-card rounded-0">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <form v-on:submit="submit">
        <div class="row">

          <!-- CONTACTS -->
          <div class="col-12">
            <h4 class="mb-15">{{ $t('feature.auth.$invitation.email_address') }}</h4>
            <p>{{ $t('feature.auth.$invitation.instructions') }}</p>
          </div>
          <!-- CREATE -->
            <!-- EMAIL -->
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  {{ $t('form.email.label') }}*
                </label>
                <input v-model="email" type="email" class="form-control shadow-none text-black" required
                  pattern="[^@\s]+@[^@\s]+\.[^@\s]+" :placeholder="$t('form.email.placeholder')"
                  :class="[{ 'is-invalid': submitted && errors?.email }]" />
                <!-- ERRORS -->
                <div class="form-messages mt-2 px-1" v-if="errors?.email ?? false">
                  <p v-for="error in errors.email" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                    error }}</p>
                </div>
              </div>
            </div>

          <div class="col-12" v-if="loading">
            <SpinnerLoading />
          </div>
          <div class="col-md-12" v-else>
            <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">

              <!-- SAVE -->
              <div class="d-flex flex-wrap gap-3 justify-content-end ms-auto">
                <DiscardButton @confirm="$router.push({
                  path: '/'
                })" />
                <button
                  class="default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
                  type="submit" v-on:click="submitted = true">
                  {{ $t('cta.invite_user') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- ERROR MESSAGE -->
  <div class="row justify-content-center">
    <div class="col">
      <div
        class="alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25"
        role="alert" id="errorMessage">
        <strong>{{ error_message }}</strong>
        <button type="button" class="btn-close" v-on:click="hideError" aria-label="Close"></button>
      </div>
    </div>
  </div>
  <AlertModal id="successModal" :title="$t('feature.auth.invitation')" :dismissible="false"
    :message="$t('feature.auth.$invitation.send_success_message')" @confirm="redirect" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DiscardButton from "@/components/Widgets/DiscardButton.vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import { CreateUserInfo, Role, RoleInfo, UserInfo } from "@/utils/models/user.model";
import { removeNullProperties } from "@/utils/methods/remove_null_properties";
import API from "@/services/api/api.service";
import AlertModal from "@/components/Widgets/AlertModal.vue";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "InviteUserForm",
  components: {
    SpinnerLoading,
    DiscardButton,
    AlertModal
  },
  data: function () {
    return {
      email: undefined as string | undefined,
      user: {
        role_id: this.$route.query?.role_id !== undefined ? parseInt(this.$route.query?.role_id as string) : undefined
      } as CreateUserInfo,
      submitted: false,
      loading: false,
      errors: undefined as any,
      error_message: undefined as string | undefined,
      center_id: this.$route.query?.center_id as string | undefined,
      successModal: null as Modal | null,
    }
  },
  mounted() {
    this.successModal = new Modal('#successModal', {});
  },
  computed: {
    role_id_param(): number | undefined { return this.$route.query?.role_id !== undefined ? parseInt(this.$route.query?.role_id as string) : undefined; },
    update() {
      return this.$route.meta.user !== undefined && this.$route.meta.user !== null;
    },
  },
  methods: {
    submit(event): void {
      this.hideError();
      this.errors = undefined;
      this.error_message = undefined;
      event.preventDefault();

      this.loading = true;
      console.log('CREATE');

      API.sendInvite({email: this.email ?? ''}).then((response) => {
        console.log('RES', response);
        if(response.data.success === true) {
          this.successModal?.show();
        } else {
          this.errors = response.data.errors;
          this.error_message = response.data.message ?? this.$t('error.something_went_wrong');
          this.showError();
        }
      }).catch((error) => {
        this.error_message = error?.data?.message ?? error?.response?.data?.message ?? this.$t('error.something_went_wrong');
        this.errors = error?.data?.errors ?? error?.response?.data?.errors;
        this.showError();
      }).finally(() => {
        this.loading = false;
      });
    },
    showError() {
      const error = document.getElementById('errorMessage');
      error?.classList.add('show');
      setTimeout(() => {
        this.hideError();
      }, 5000)
    },
    hideError() {
      const error = document.getElementById('errorMessage');
      error?.classList.remove('show');
    },
    redirect() {
      this.successModal?.hide();
      this.$router.push('/');
    },
  },
});
</script>